import { t, useI18n } from "@bookingcom/lingojs-react";
import useSearchFiltersController from "../../useSearchFiltersController.js";
import { useEffect, useState, useRef, useCallback } from "react";
import debounce from "lodash/debounce";
import { useTrackLayoverPriceAirportFilterWeb } from "../../../../../utils/experiments/funnel/flights_funnel_layover_price_airport_filter_web.js";
const useDebouncedCallback = (callback, delay) => {
    const debouncedFn = useRef();
    useEffect(() => {
        debouncedFn.current = debounce((...args) => {
            callback(...args);
        }, delay);
        return () => {
            debouncedFn.current?.cancel();
        };
    }, [callback, delay]);
    return useCallback((...args) => {
        debouncedFn.current?.(...args);
    }, []);
};
export const useDurationFilterController = () => {
    const i18n = useI18n();
    const { duration } = useSearchFiltersController();
    const [value, setValue] = useState(duration.value);
    const lastCommittedValueRef = useRef(duration.value);
    useEffect(() => {
        setValue(duration.value);
        lastCommittedValueRef.current = duration.value;
    }, [duration.value]);
    const debouncedDurationSet = useDebouncedCallback(duration.set, 300);
    const handleChangeCommit = (newValue) => {
        if (newValue !== lastCommittedValueRef.current) {
            lastCommittedValueRef.current = newValue;
            debouncedDurationSet(newValue);
        }
    };
    const trackLayoverPriceAirportFilterWeb = useTrackLayoverPriceAirportFilterWeb();
    return {
        isFilterAvailable: duration.options.max !== duration.options.min,
        title: i18n.trans(t("flights_filters_duration_title")),
        resetLabel: i18n.trans(t("flights_filter_reset")),
        showReset: trackLayoverPriceAirportFilterWeb() ? false : duration.touched,
        onClickReset: duration.reset,
        min: duration.options.min,
        max: duration.options.max,
        value,
        ariaLabel: `${i18n.trans(t("flights_filters_duration_travel_time_title"))}, ${i18n.trans(t("a11y_flights_filter_duration_announce"))}`,
        label: i18n.trans(t("flights_filters_duration_travel_time_title")),
        onChange: (value) => setValue(value),
        onChangeCommit: handleChangeCommit,
        renderTooltipValue: (value) => i18n.trans(t("flights_filters_duration_hours", { variables: { num_exception: value, num_hours: value.toString() } })),
        renderValue: (value) => i18n.trans(t("flights_filters_duration_hours", {
            variables: { num_exception: value, num_hours: value.toString() }
        })),
        keyForRemount: `duration-${duration.options.min}-${duration.options.max}`
    };
};
